import { useState } from 'react';
import { PageContainer } from '../../components/layout/PageContainer.js';
import { Button } from '../../components/ui/Button.js';
import { useAuth } from '../auth/useAuth.js';
import { CreateToolLibraryForm } from './components/CreateToolLibraryForm.js';
import { ToolLibraryTable } from './components/ToolLibraryTable.js';
import { useToolLibrary } from './hooks/useToolLibrary.js';

export function ToolingPage(): JSX.Element {
  const { shopId } = useAuth();
  const { data, isLoading, isError, refetch } = useToolLibrary(shopId);
  const [creating, setCreating] = useState(false);

  return (
    <PageContainer>
      <div className="mb-5 flex items-end justify-between">
        <div>
          <h1 className="font-mono text-base">Tooling</h1>
          <p className="text-xs text-text-dim">
            Manage the shop&apos;s tool library. Library entries can be assigned to slots
            from any machine&apos;s tool panel.
          </p>
        </div>
        {!creating && (
          <Button variant="primary" onClick={() => setCreating(true)}>
            + Add tool
          </Button>
        )}
      </div>

      {creating && shopId && (
        <section className="rounded-md border border-border bg-card p-4 mb-5">
          <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-text-dim mb-3">
            New tool library entry
          </h2>
          <CreateToolLibraryForm
            shopId={shopId}
            onCreated={() => setCreating(false)}
            onCancel={() => setCreating(false)}
          />
        </section>
      )}

      <section className="rounded-md border border-border bg-card overflow-hidden">
        <header className="px-4 py-3 border-b border-border flex items-center justify-between">
          <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-text-dim">
            Library
          </h2>
          {data && data.length > 0 && (
            <span className="text-[10px] font-mono text-text-dim">
              {data.length} {data.length === 1 ? 'tool' : 'tools'}
            </span>
          )}
        </header>
        <ToolLibraryTable
          shopId={shopId}
          entries={data}
          isLoading={isLoading}
          isError={isError}
          onRetry={refetch}
        />
      </section>
    </PageContainer>
  );
}
